// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"447":"component-lazy","741":"side-panel-card-lazy"}[chunkId] || chunkId) + "." + {"447":"f4591cdcc38be6ea3ddc","741":"1349846fd5d5a8cbb157","898":"23dce5a3575e5f2735b5"}[chunkId] + ".js";
};